module.exports = __webpack_public_path__ + "img/01.ed2ad007.jpg";